import { init, browserTracingIntegration, captureConsoleIntegration } from "@sentry/vue";

/**
 *
 * @param {import("vue-router").Router} router
 * @returns {import("vue").FunctionPlugin}
 */
export function createSentry(router) {
  return function (app) {
    if (import.meta.env.SSR) return;
    init({
      app,
      dsn: "https://60cecc623c71798da8a8c1474ea86296@o4511699948929024.ingest.de.sentry.io/4511700241023056",
      integrations: [browserTracingIntegration({ router }), captureConsoleIntegration({ levels: ["error"] })],
      ignoreErrors: [
        "AppError",
        "Cookie Control failed to verify your settings",
        "via a navigation guard",
        "Network Error",
        "There was an error setting cookie",
      ],
    });
  };
}
